"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageToJSON = exports.MessageFromJSONTyped = exports.MessageFromJSON = void 0;
function MessageFromJSON(json) {
    return MessageFromJSONTyped(json, false);
}
exports.MessageFromJSON = MessageFromJSON;
function MessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': json['description'],
        'flags': json['flags'],
    };
}
exports.MessageFromJSONTyped = MessageFromJSONTyped;
function MessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'flags': value.flags,
    };
}
exports.MessageToJSON = MessageToJSON;
//# sourceMappingURL=Message.js.map